// extracted by mini-css-extract-plugin
module.exports = {"Auth":"_1TIntFyKjbqLA5PQlrm5b8","AuthForm":"_38dS6yb3CqSRLrYt4SfDlx"};